import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {AMENORRHOEA_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/amenorrhoea-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/amenorrhoea-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/amenorrhoea-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/amenorrhoea-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/amenorrhoea-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const AmenorrhoeaTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case AMENORRHOEA_TEST_KEYS.START:
        trackPageViewGA('/amenorrhoea-test/start', 'MDQ-Amenorrhoea Test - Start');
        return <Questionnaire1Screen />;
      case AMENORRHOEA_TEST_KEYS.PROFILE:
        trackPageViewGA('/amenorrhoea-test/profile', 'MDQ-Amenorrhoea Test - Profile');
        return <Questionnaire2Screen />;
      case AMENORRHOEA_TEST_KEYS.INVALID:
        trackPageViewGA('/amenorrhoea-test/invalid', 'MDQ-Amenorrhoea Test - Invalid');
        return <Questionnaire3Screen />;
      case AMENORRHOEA_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA('/amenorrhoea-test/appointment-preferences', 'MDQ-Amenorrhoea Test - Appointment Preferences');
        return <Questionnaire4Screen />;
      case AMENORRHOEA_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/amenorrhoea-test/your-test-package', 'MDQ-Amenorrhoea Test - Your Test Package');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default AmenorrhoeaTest;
